import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["coreCustom", "coreFieldIdInput", "internalInput", "multipleChoiceInput", "nameInput"];
  }

  static get values() {
    return { multiChoiceCoreFieldIds: String };
  }

  connect() {
    // console.log("connected");
    this.configureFields();
  }

  configureFields() {
    if (this.chooseCustomField) {
      this.disableCoreFieldInput();
      this.enableMultiChoiceInput();
      this.enableInternalInput();
    } else {
      this.enableCoreFieldInput();

      if (this.multiChoiceCoreFieldSelected) { 
        this.disableMultiChoiceInput();
      } else {
        this.enableMultiChoiceInput();
      }

      this.disableInternalInput();
    }
  }

  get chooseCustomField() {
    return this.coreCustomTarget.value === "custom";
  }

  enableCoreFieldInput() {
    this.coreFieldIdInputTarget.value = this.coreCustomTarget.value;
    this.coreFieldIdInputTarget.disabled = false;

    if (this.hasNameInputTarget && this.nameInputTarget.value === "") {
      this.nameInputTarget.value = this.coreCustomTarget.options[this.coreCustomTarget.selectedIndex].text;
    }
  }

  disableCoreFieldInput() {
    this.coreFieldIdInputTarget.value = null;
    this.coreFieldIdInputTarget.disabled = true;

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = null;
    }
  }

  enableInternalInput() {
    if (!this.hasInternalInputTarget) return;

    this.internalInputTarget.disabled = false;
    this.internalInputTarget.closest("input").disabled = false;
    this.internalInputTarget.closest(".input-field").classList.remove("dn");
    this.internalInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = false;
  }

  disableInternalInput() {
    if (!this.hasInternalInputTarget) return;

    this.internalInputTarget.closest(".input-field").classList.add("dn");
    this.internalInputTarget.disabled = true;

    this.internalInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = true;
  }

  enableMultiChoiceInput() {
    if (!this.hasMultipleChoiceInputTarget) return;

    this.multipleChoiceInputTarget.disabled = false;
    this.multipleChoiceInputTarget.closest(".input-field").classList.remove("dn");
    this.multipleChoiceInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = false;
  }

  disableMultiChoiceInput() {
    if (!this.hasMultipleChoiceInputTarget) return;

    this.multipleChoiceInputTarget.closest(".input-field").classList.add("dn");
    this.multipleChoiceInputTarget.disabled = true;
    this.multipleChoiceInputTarget.closest("label")
      .querySelector("input[type=\"hidden\"]")
      .disabled = true;
  }

  get multiChoiceCoreFieldIds() {
    return this.multiChoiceCoreFieldIdsValue.split(" ");
  }

  get multiChoiceCoreFieldSelected() {
    return this.multiChoiceCoreFieldIds.includes(this.coreCustomTarget.value);
  }
}


